import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import AboutPage from "@/pages/about/page";
import FAQPage from "@/pages/faq/page";
import StoresPage from "@/pages/stores/page";
import Blog from "@/pages/blog/page";
import BlogArticlePage from "@/pages/blog/article/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/home", element: <Home /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/stores", element: <StoresPage /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <BlogArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
